/**
 * The locale to request the public ready-to-use agent catalog in, from the landing page language.
 * The landing is prerendered per locale but the catalog is fetched in the browser, so the language
 * must be sent explicitly or visitors would see English names on a Portuguese page.
 * A bare "pt" means pt-BR, like the app; anything unsupported is English.
 */
const LOCALES = ["en", "pt-PT", "pt-BR", "es", "fr", "de", "it"] as const;

export function toCatalogLocale(language: string | null | undefined): string {
  const raw = (language ?? "").replace("_", "-").trim();
  if (!raw) return "en";
  const exact = LOCALES.find((l) => l.toLowerCase() === raw.toLowerCase());
  if (exact) return exact;
  const base = raw.split("-")[0]?.toLowerCase();
  if (base === "pt") return "pt-BR";
  return LOCALES.find((l) => l === base) ?? "en";
}
